module.exports = __webpack_public_path__ + "85c20dbeb555b771a3e28c4d604bdd2b.png";